import { memo } from 'react';

import { cn } from '../../lib/styles';

export interface SubInfoCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const SubInfoCardBase = ({ children, style, className, ...rest }: SubInfoCardProps) => {
  return (
    <div
      style={style}
      className={cn('rounded-sm p-3 border border-border-default font-body-sm min-w-0', className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const SubInfoText = ({ children }: { children: React.ReactNode }) => {
  return <div className="text-text-primary font-body-sm">{children}</div>;
};

export const SubInfoCard = memo(SubInfoCardBase);
